import React, { useState } from "react";
import {
  WhatsAppTemplate,
} from "../../components/types";

import { existingTemplates, samplePrompts, templateTypes } from "./data";
import Header from "../../components/marketing/templates/header";
import Navigation from "../../components/marketing/templates/navigation";
import CreateTemplates from "../../components/marketing/templates/create-templates";
import TemplateModal from "../../components/marketing/templates/template-modal";

const WhatsAppTemplateCreator: React.FC = () => {
  const [prompt, setPrompt] = useState<string>("");
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [generatedTemplate, setGeneratedTemplate] =
    useState<WhatsAppTemplate | null>(null);
  const [feedback, setFeedback] = useState<string>("");
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [templateType, setTemplateType] = useState<string>("marketing");
  const [activeTab, setActiveTab] = useState<string>("create");
  const [selectedTemplate, setSelectedTemplate] =
    useState<WhatsAppTemplate | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterType, setFilterType] = useState<string>("all");



  const filteredTemplates = existingTemplates.filter((template) => {
    const matchesSearch =
      template.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      template.body.text.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter =
      filterType === "all" || template.category === filterType.toUpperCase();
    return matchesSearch && matchesFilter;
  });

  const mockGenerateTemplate = async (
    promptText: string,
    type: string
  ): Promise<void> => {
    setIsGenerating(true);

    // Simulate AI processing
    await new Promise((resolve) => setTimeout(resolve, 2500));

    const templates: Record<string, WhatsAppTemplate> = {
      marketing: {
        name: "welcome_offer_new_customers",
        category: "MARKETING",
        language: "en",
        header: {
          type: "TEXT",
          text: "🎉 Welcome to {{1}}!",
        },
        body: {
          text: "Hi {{1}}! 👋\n\nWelcome to our family! We're excited to have you on board.\n\n🎁 As a warm welcome, here's an exclusive 20% OFF on your first purchase!\n\nUse code: WELCOME20\n\n✨ Valid for the next 48 hours\n💝 Minimum order: $50\n🚀 Free shipping included\n\nStart shopping now and discover amazing products crafted just for you!",
        },
        footer: {
          text: "Terms apply. Offer expires in 48 hours.",
        },
        buttons: [
          {
            type: "URL",
            text: "Shop Now 🛒",
            url: "https://{{1}}/shop?code=WELCOME20",
          },
          {
            type: "PHONE_NUMBER",
            text: "Call Support",
            phone_number: "+1234567890",
          },
        ],
      },
      transactional: {
        name: "order_confirmation_tracking",
        category: "TRANSACTIONAL",
        language: "en",
        header: {
          type: "TEXT",
          text: "📦 Order Confirmed!",
        },
        body: {
          text: "Hi {{1}},\n\nYour order has been confirmed! 🎉\n\n📋 Order Details:\n• Order ID: {{2}}\n• Amount: ${{3}}\n• Items: {{4}}\n\n📍 Shipping Address:\n{{5}}\n\n🚚 Tracking ID: {{6}}\n\nEstimated delivery: {{7}}\n\nThank you for choosing us!",
        },
        buttons: [
          {
            type: "URL",
            text: "Track Order 📱",
            url: "https://{{1}}/track/{{6}}",
          },
        ],
      },
    };

    const template = templates[type] || templates.marketing;
    setGeneratedTemplate(template);
    setIsGenerating(false);
  };

  const handleGenerate = (): void => {
    if (!prompt.trim()) return;
    mockGenerateTemplate(prompt, templateType);
  };

  const handleFeedback = (type: "positive" | "negative"): void => {
    if (type === "positive") {
    } else {
    }
  };

  const handleRegenerate = (): void => {
    if (generatedTemplate && prompt) {
      mockGenerateTemplate(
        prompt + (feedback ? ` Additional context: ${feedback}` : ""),
        templateType
      );
      setFeedback("");
    }
  };

  const copyTemplate = (): void => {
    if (generatedTemplate) {
      navigator.clipboard.writeText(JSON.stringify(generatedTemplate, null, 2));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50">
      {/* Header */}
      <Header />
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Tab Navigation */}
        <Navigation
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          existingTemplates={existingTemplates}
        />

        <CreateTemplates
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          existingTemplates={existingTemplates}
          templateTypes={templateTypes}
          samplePrompts={samplePrompts}
          filteredTemplates={filteredTemplates}
          templateType={templateType}
          setTemplateType={setTemplateType}
          isGenerating={isGenerating}
          setIsGenerating={setIsGenerating}
          prompt={prompt}
          setPrompt={setPrompt}
          handleGenerate={handleGenerate}
          handleFeedback={handleFeedback}
          generatedTemplate={generatedTemplate}
          setGeneratedTemplate={setGeneratedTemplate}
          handleRegenerate={handleRegenerate}
          setShowPreview={setShowPreview}
          showPreview={showPreview}
          feedback={feedback}
          setFeedback={setFeedback}
          copyTemplate={copyTemplate}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filterType={filterType}
          setFilterType={setFilterType}
          setSelectedTemplate={setSelectedTemplate}
        />

        {/* Template Detail Modal */}
        <TemplateModal
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
        />
      </div>
    </div>
  );
};

export default WhatsAppTemplateCreator;
